module.exports = __webpack_public_path__ + "static/media/Fuzz Modeler High Gain VR.9c2cadc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Fuzz Modeler High Gain VR.mp3
// module id = nB7a
// module chunks = 12